<template>
  <transition
    name="slide"
    @before-enter="before($event, 'enter')"
    @enter="during($event, 'enter')"
    @after-enter="after"
    @before-leave="before($event, 'leave')"
    @leave="during($event, 'leave')"
    @after-leave="after"
  >
    <slot/>
  </transition>
</template>

<script>
  export default {
    data() {
      return {
        height: undefined,
        overflow: undefined,
      };
    },
    methods: {
      before({ style, scrollHeight }, event) {
        this.height = style.height;
        this.overflowY = style.overflowY;

        style.setProperty('height', { enter: '0', leave: `${scrollHeight}px` }[event]);
        style.setProperty('overflow-y', 'hidden');
      },
      during({ style, scrollHeight }, event) {
        style.setProperty('height', { enter: `${scrollHeight}px`, leave: '0' }[event]);
      },
      after({ style }) {
        style.setProperty('height', this.height);
        style.setProperty('overflow-y', this.overflowY);
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .slide-enter-active,
  .slide-leave-active {
    transition-duration: duration(slow);
    transition-property: height;
    transition-timing-function: timing-function(decelerate);
  }
</style>
